import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ExclamationTriangleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import { quizApi } from '../../services/quizApi';
import { WrongAnswersModal } from './WrongAnswersModal';

interface ResultsActionButtonsProps {
  subjectId: string;
  subjectName: string;
  hasWrongAnswers: boolean;
  questionCount?: number;
  wrongAnswers?: any[];
  sessionId?: string; // ID della sessione originale per duplicarla con shuffle
}

export const ResultsActionButtons: React.FC<ResultsActionButtonsProps> = ({ 
  subjectId, 
  subjectName, 
  hasWrongAnswers,
  questionCount = 20,
  wrongAnswers = [],
  sessionId
}) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleRepeatTest = async () => {
    try {
      if (sessionId) {
        // Duplica la sessione con le stesse domande ma rimescolate
        console.log('🔄 [DEBUG] Duplicando sessione con domande rimescolate:', sessionId);
        const newSession = await quizApi.duplicateSession(sessionId);
        console.log('✅ [DEBUG] Nuova sessione creata:', newSession.id);
        navigate(`/quiz/${newSession.id}`);
      } else {
        // Fallback: crea una nuova sessione se non abbiamo il sessionId
        console.log('🔄 [DEBUG] Creando nuova sessione per fallback');
        const newSession = await quizApi.createSession(subjectId, questionCount);
        navigate(`/quiz/${newSession.id}`);
      }
    } catch (error) {
      console.error('Errore durante il riavvio del test:', error);
      alert('Errore durante il riavvio del test. Riprova.');
    }
  };

  return (
    <div className="bg-white border-t border-gray-200 py-4 px-4">
      <div className="max-w-md mx-auto">
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {/* Pulsante Vedi Risposte Errate */}
          {hasWrongAnswers && (
            <button
              onClick={() => setIsModalOpen(true)}
              className="btn-secondary flex items-center justify-center space-x-2 text-sm py-3 px-4 flex-1"
            >
              <ExclamationTriangleIcon className="h-4 w-4" />
              <span>Vedi Risposte Errate</span>
            </button>
          )}

          {/* Pulsante Ripeti il Test */}
          <button
            onClick={handleRepeatTest}
            className="btn-primary flex items-center justify-center space-x-2 text-sm py-3 px-4 flex-1"
          >
            <ArrowPathIcon className="h-4 w-4" />
            <span>Ripeti Questo Test</span>
          </button>
        </div>
      </div>

      {/* Modale Risposte Errate */}
      <WrongAnswersModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        wrongAnswers={wrongAnswers}
      />
    </div>
  );
};
